const manageAdminProfileConstantsAr = {
  manageAdminProfileHederTitle: 'تعديل الملف الشخصي',
  manageAdminProfileBackButton: 'العودة',
  manageAdminProfileRoleOption1: 'مدير',
  manageAdminProfileRoleOption2: 'مدخل بيانات',
  manageAdminProfileSubtitle1: 'معلومات المستخدم',
  manageAdminProfileSubtitle2: 'دور المستخدم',
  manageAdminProfileSubtitle3: 'تغيير كلمة المرور',
  manageAdminProfileEmailLabel: 'البريد الإلكتروني',
  manageAdminProfileFirstNameLabel: 'الاسم الأول',
  manageAdminProfileLastNameLabel: 'الاسم الأخير',
  manageAdminProfilePhoneLabel: 'رقم الهاتف',
  manageAdminProfileJobTitleLabel: 'المسمى الوظيفي',
  manageAdminProfileChangePasswordButton: 'تغيير كلمة المرور',
  manageAdminProfileSaveButton: 'حفظ',
  changePasswordDialogTitle: 'تغيير كلمة المرور',
  changePasswordDialogOldPasswordLabel: 'كلمة المرور الحالية',
  changePasswordDialogNewPasswordLabel: 'كلمة المرور الجديدة',
  changePasswordDialogConfirmPasswordLabel: 'تأكيد كلمة المرور الجديدة',
  changePasswordDialogSendOtpButton: 'إرسال رمز التحقق',
  changePasswordDialogOldPasswordEmptyInputError: 'كلمة المرور الحالية مطلوبة',
  changePasswordDialogOldPasswordWrongError: 'كلمة المرور الحالية غير صحيحة',
  changePasswordDialogNewPasswordEmptyInputError: 'كلمة المرور الجديدة مطلوبة',
  changePasswordDialogConfirmPasswordError: 'كلمة المرور غير متطابقة',
  changePasswordDialogNewPasswordSameAsOldError: 'كلمة المرور الجديدة لا يمكن أن تكون نفس كلمة المرور الحالية',
  requiredField: 'هذا الحقل مطلوب',
};

export default manageAdminProfileConstantsAr;
